import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { CostCenterServiceLink, CostCenterConditionTargetingModel, LinkedMappingsService } from "./linked-mappings-service";
import { ServiceTargeting, IDimension } from "./service-targeting";
import { TreeNode } from '../../../components/tree-view/tree-node';
import { OrganizationalNodeModel } from '../../customers/organizational-units/organizational-unit-service';
import { filter, sortBy } from "lodash";
import {AccountingDimensionValue} from "../../accounting-dimensions/accounting-dimension-api";

/*** UI component for showing one costcenter's dimensions and their service targetings */
@autoinject
export class CostCenterConditionsList {
	@bindable costCenterId: string;
	@bindable currentNode: OrganizationalNodeModel;
	@bindable dimensions: IDimension[];
	@bindable serviceStructureId: string;

	private costCenterServicesLocal: CostCenterServiceLink[] = [];
	showTargetingEditForm: boolean = false;

	private ignoredCssClass = 'ignored';

	constructor(
		private linkedMappingsService: LinkedMappingsService,
		private serviceTargeting: ServiceTargeting) {
	}

	@computedFrom("linkedMappingsService.costCenterConditionsCache")
	get costCenterConditionTargetings(): CostCenterConditionTargetingModel[] {
		if (!this.linkedMappingsService.costCenterConditionsCache) {
			return [];
		}

		return sortBy(
			this.linkedMappingsService.costCenterConditionsCache
				.filter((condition: CostCenterConditionTargetingModel) => condition.costCenterId === this.costCenterId),
			c => c.formattedName);
	}

	@computedFrom("linkedMappingsService.costCenterServiceLinksCache")
	get costCenterServices(): CostCenterServiceLink[] {
		return this.getCostCenterServiceLinks(null);
	}

	getCostCenterServiceLinks(dimensionValueIds: string[]): CostCenterServiceLink[] {

		const allLinks = this.linkedMappingsService.costCenterServiceLinksCache;
		if (!allLinks) { return []; }

		this.costCenterServicesLocal = filter(allLinks, (link: CostCenterServiceLink) =>
			(link.costCenterId === this.costCenterId) &&
			AccountingDimensionValue.areValuesEqual(link.dimensionValueIds, dimensionValueIds)
		);

		return this.costCenterServicesLocal;
	}
	
	toggleCollectMeasures(conditionTargeting: CostCenterConditionTargetingModel, serviceId: string, shouldBeCollected: boolean) {
		this.linkedMappingsService.toggleCollectMeasuresForCondition(conditionTargeting, serviceId, shouldBeCollected, this.serviceStructureId);
	}

	removeTargeting(conditionTargeting: CostCenterConditionTargetingModel) {
		this.linkedMappingsService.removeCostCenterCondition(conditionTargeting, this.serviceStructureId);
	}

	isCollectingMeasuresForCondition(conditionTargeting: CostCenterConditionTargetingModel, serviceId: string): boolean {
		return this.getCostCenterServiceLinks(conditionTargeting.requiredDimensionValues.map(c => c.dimensionValueId))
			.some(l => l.serviceId == serviceId);
	}
}
